var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0067FF",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wrench") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.295 8.475l-6.571 6.571-5.617-1.495-1.494-5.617 6.571-6.571c-3.298-0.851-6.953-0.005-9.534 2.577-2.737 2.737-3.544 6.678-2.422 10.126l-10.165 10.165v6.487h6.268l10.28-10.28c3.443 1.114 7.376 0.305 10.108-2.428 2.584-2.584 3.433-6.233 2.577-9.534z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaintenance);
export default __webpack_public_path__ + "static/media/icon-maintenance.cf5b5b07f34a460e07d773e914a8bf31.svg";
export { ForwardRef as ReactComponent };